import Vue from "vue";
import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    InventoryDealerSettings: [],
    InventoryPhotosModalInfo: {
      showModal: false,
      stockNumber: null
    },
    SelectedReplacementVehicle: null,
    InventorySearchRequest: null,
    InventorySearchResults: null,
    InventoryTotalRecords: 0,
    InventorySearchPagination: {
      pageNumber: 1,
      pageSize: 25,
      pageTotal: 0
    },
    InventorySearchSort: {
      sortField: "price",
      sortDirection: "asc"
    },
    InventorySearchSpinner: false,
    InventoryLayoutModalInfo: {
      showModal: false,
      data: null
    },
    VehiclesSelectedForComparison: [],
    InventoryVehicleComparisonModalInfo: {
      showModal: false,
      data: null
    },
    InventoryProcessModalInfo: {
      showModal: false,
      data: null
    },
    InventorySavedSearchModalInfo: {
      showModal: false,
      data: null
    },
    LeadCountsForInventory: [],
    FindBuyerCustomersFilter: null,
    InventoryDays: ''
  };
}

const state = initialState();

const getters = {
  InventoryDealerSettings: function() {
    return state.InventoryDealerSettings;
  },
  SelectedReplacementVehicle: function() {
    return state.SelectedReplacementVehicle;
  },
  FindBuyerCustomersFilter: function() {
    return state.FindBuyerCustomersFilter;
  },
  InventoryDays: function() {
    return state.InventoryDays;
  },
};

const actions = {
  searchInventoryVehicle(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.InventoryApiClient.ProcessRequest(
        "POST",
        "/api/Inventory/advanced-search",
        request
      )
        .then(response => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getInventoryDealerSettings(context) {
    return context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      "/api/dealer"
    ).then(response => {
      if (response && response.data) {
        context.commit("updateInventoryDealerSettings", response.data);
        return response.data;
      } else throw new Error("Unknown error occurred");
    });
  },
  carFaxAuthorize(context, request) {
    return context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      "/api/dealer/CarFaxAuthorize",
      request,
      null,
      null,
      true
    ).then(response => {
      if (response && response.data && response.data.length > 0) {
        return response.data;
      } else throw new Error("Unknown error occurred");
    });
  },
  getCarFaxUrlFromAuthCode(context, request) {
    return context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      `/api/dealer/GetCarFaxUrlFromAuthCode?code=${request.code}&state=${request.state}&redirectUri=${request.redirectUri}`,
      null,
      null,
      null,
      true
    ).then(response => {
      if (response && response.data && response.data.length > 0) {
        return response.data;
      } else throw new Error("Unknown error occurred");
    });
  },
  handleCarfaxLogout(context) {
    return context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      `/api/dealer/CarFaxLogout`,
      null,
      null,
      null,
      true
    ).then(response => {
      if (response) {
        return response;
      } else throw new Error("Unknown error occurred");
    });
  },
  inStockInventorySearch: function(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.InventoryApiClient.ProcessRequest(
        "POST",
        "/api/inventory/in-stock-match-search",
        request
      )
        .then(response => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMultipleVehicleOffers: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/Dealsheet/entity/${request.entityId}/vehicle_replacements`,
          request.requestBody,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getAutoCheckReport: async function(context, request) {
    this.response = await context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      "/api/Dealer/GetAutoCheck",
      request
    );
    return this.response && this.response.data ? this.response.data : null;
  },
  openInventoryPhotosModal(context, photoModalDetails) {
    context.commit("openInventoryPhotosModal", photoModalDetails);
  },
  closeInventoryPhotosModal(context) {
    context.commit("closeInventoryPhotosModal");
  },
  setReplacementVehicle(context, vehicleDetails) {
    context.commit("setReplacementVehicle", vehicleDetails);
  },
  setInventoryDays(context, days) {
    context.commit("setInventoryDays", days);
  },
  async getDealerRecalls(context, request) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      "/api/inventory/dealer-recall-list",
      request
    );
    return response && response.data ? response.data : null;
  },
  updateInventorySearchFilters(context, request) {
    context.commit("updateInventorySearchFilters", request);
  },
  updateInventorySearchPagination(context, data) {
    context.commit("updateInventorySearchPagination", data);
  },
  async getInventorySearchResults(context, request) {
    context.commit("updateInventorySearchSpinner", true);
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      "/api/inventory/search",
      request.payload
    ).catch(ex => {
      context.commit("updateInventorySearchSpinner", false);
      context.commit("updateInventorySearchResults", []);
    });
    if (response && response.data) {
      context.commit("updateInventorySearchResults", response.data.results);
      context.dispatch("getLeadCountsForResults", {
        payload: request.payload.searchCriteria,
        results: response.data.results
      });
      context.commit("updateInventorySearchPagination", {
        totalRecords: response.data.totalDocumentCount,
        pagination: request.pagination,
        isIndividualUpdate: true
      });
      context.commit(
        "updateInventoryTotalRecords",
        response.data.totalDocumentCount
      );
    }
    context.commit("updateInventorySearchSpinner", false);
  },
  async getLeadCountsForResults(context, data) {
    if (!data || data.length == 0) {
      context.commit("updateLeadCountsForInventory", []);
      return;
    }
    let request = {
      accountPlatformIds: data.payload.accountPlatformIds,
      vins: data.results.map(x => x.inventoryVIN),
      stockNumbers: data.results.map(x => x.inventoryStockNumber),
      countOnly: true,
      salesPersonIds: [],
      pagination: {
        pageSize: 100,
        pageNumber: 1
      },
      sortDescriptor: {
        sortBy: "lastName",
        sortDirection: 0
      }
    };

    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/CrmLead/inventory/leads",
      request
    );
    if (response && response.data)
      context.commit("updateLeadCountsForInventory", response.data.data || []);
    else context.commit("updateLeadCountsForInventory", []);
    return response && response.data ? response.data.data : [];
  },
  async fetchLeadCountDetails(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/CrmLead/inventory/leads",
      request
    );
    return response && response.data ? response.data : null;
  },
  updateFindBuyerCustomersFilter(context, data) {
    context.commit("updateFindBuyerCustomersFilter", data);
  },
  updateInventoryLayoutModal(context, data) {
    context.commit("updateInventoryLayoutModal", data);
  },
  updateVehiclesSelectedForComparison(context, data) {
    context.commit("updateVehiclesSelectedForComparison", data);
  },
  updateInventoryVehicleComparisonModalInfo(context, data) {
    context.commit("updateInventoryVehicleComparisonModalInfo", data);
  },
  async getInventoryOpportunities(context, payload) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      "/api/entity/searchOpportunities",
      payload
    );
    return response && response.data ? response.data : null;
  },
  async getDealerInventorySettings(context) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      "/api/Dealer"
    );
    return response && response.data ? response.data : null;
  },
  async getInventorySavedSearches(context) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      "/api/saved-searches"
    );
    return response && response.data ? response.data : null;
  },
  async saveInventorySearch(context, payload) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      `${payload.type}`,
      `/api/saved-searches${payload.id > 0 ? "/" + payload.id : ""}`,
      payload
    );
    return response && response.data ? response.data : null;
  },
  async fetchVINRecallDetails(context, vehicle) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      `/api/vinRecall/GetByDealerVehicle/${vehicle.dealerId}/${vehicle.recallVehicleId}`
    );
    return response && response.data ? response.data : null;
  },
  async getInventoryProcesses(context, dealerId) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "GET",
      `/api/workflows/${dealerId}`
    );
    return response && response.data ? response.data : null;
  },
  updateInventoryProcessModal(context, data) {
    context.commit("updateInventoryProcessModal", data);
  },
  async startInventoryProcess(context, payload) {
    let response = await context.getters.InventoryApiClient.ProcessRequest(
      "POST",
      `/api/workflows/`,
      payload
    );
    return response && response.data ? response.data : null;
  },
  updateInventorySavedSearchModalInfo(context, payload) {
    context.commit("updateInventorySavedSearchModalInfo", payload);
  },
  async findBuyer(context, payload) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/Inventory/find_a_buyer",
      payload
    );
    return response && response.data ? response.data : null;
  },
  async findBuyerCustomers(context, payload) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/Inventory/find_a_buyer_customers",
      payload
    );
    return response && response.data ? response.data : null;
  },
  async topCarSalesOpp(context, payload) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/Inventory/top_used_car_sales_opportunities",
      payload
    );
    return response && response.data ? response.data : null;
  },
  async agedInventoryOpp(context, payload) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/Inventory/inventory_aged_opportunities",
      payload
    );
    return response && response.data ? response.data : null;
  },
};

const mutations = {
  setInventoryDays(state, data) {
    state.InventoryDays = data;
  },
  updateInventoryDealerSettings(state, data) {
    state.InventoryDealerSettings = data;
  },
  openInventoryPhotosModal(state, photoModalDetails) {
    state.InventoryPhotosModalInfo.stockNumber = photoModalDetails.stockNumber;
    state.InventoryPhotosModalInfo.dealerId = photoModalDetails.dealerId;
    state.InventoryPhotosModalInfo.accountPlatformId =
      photoModalDetails.accountPlatformId;
    state.InventoryPhotosModalInfo.showModal = true;
  },
  closeInventoryPhotosModal(state) {
    state.InventoryPhotosModalInfo.stockNumber = null;
    state.InventoryPhotosModalInfo.accountPlatformId = null;
    state.InventoryPhotosModalInfo.showModal = false;
  },
  setReplacementVehicle(state, data) {
    state.SelectedReplacementVehicle = data;
  },
  updateInventorySearchFilters(state, data) {
    state.InventorySearchRequest = data;
  },
  updateInventorySearchResults(state, data) {
    state.InventorySearchResults = data;
  },
  updateInventorySearchPagination(state, data) {
    if (data.isIndividualUpdate) {
      let info = {
        pageSize: data.pagination.pageSize,
        pageNumber: data.pagination.pageNumber,
        pageTotal: Math.ceil(data.totalRecords / data.pagination.pageSize)
      };
      state.InventorySearchPagination = info;
    } else state.InventorySearchPagination = data;
  },
  updateInventoryTotalRecords(state, total) {
    state.InventoryTotalRecords = total;
  },
  updateInventorySearchSort(state, data) {
    state.InventorySearchSort = data;
  },
  updateInventorySearchSpinner(state, data) {
    state.InventorySearchSpinner = data;
  },
  updateFindBuyerCustomersFilter(state, data) {
    state.FindBuyerCustomersFilter = data;
  },
  updateInventoryLayoutModal(state, data) {
    state.InventoryLayoutModalInfo = data;
  },
  updateVehiclesSelectedForComparison(state, data) {
    state.VehiclesSelectedForComparison = data;
  },
  updateInventoryVehicleComparisonModalInfo(state, data) {
    state.InventoryVehicleComparisonModalInfo = data;
  },
  updateInventoryProcessModal(state, data) {
    state.InventoryProcessModalInfo = data;
  },
  updateInventorySavedSearchModalInfo(state, data) {
    state.InventorySavedSearchModalInfo = data;
  },
  updateLeadCountsForInventory(state, data) {
    state.LeadCountsForInventory = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};

export var InventoryFiltersHelper = {
  getInventoryFilters() {
    let inventorySearchFilterValues = {
      bodyStyles: [
        { value: 3, text: "Coupe" },
        { value: 5, text: "Hatchback" },
        { value: 2, text: "Minivan" },
        { value: 1, text: "Pickup Truck" },
        { value: 7, text: "Sedan" },
        { value: 6, text: "SUV" },
        { value: 9, text: "Van" },
        { value: 4, text: "Wagon" }
      ],
      cylinders: [
        { value: 3, text: "3 Cylinders" },
        { value: 4, text: "4 Cylinders" },
        { value: 5, text: "5 Cylinders" },
        { value: 6, text: "6 Cylinders" },
        { value: 8, text: "8 Cylinders" },
        { value: 10, text: "10 Cylinders" },
        { value: 12, text: "12 Cylinders" }
      ],
      drivetrains: [
        { value: 19, text: "All Wheel Drive (AWD)" },
        { value: 20, text: "Four Wheel Drive (4WD)" },
        { value: 17, text: "Front Wheel Drive (FWD)" },
        { value: 18, text: "Rear Wheel Drive (RWD)" }
      ],
      fuelEconomyMin: 0,
      fuelEconomyMax: 240,
      fuelTypes: [
        { value: 12, text: "Diesel" },
        { value: 15, text: "Electric" },
        { value: 14, text: "Electric Hybrid" },
        { value: 10, text: "Gasoline" },
        { value: 13, text: "Non-Electric Hybrid" },
        { value: 16, text: "Plug-In Hybrid Electric" },
        { value: 11, text: "Other" }
      ],
      odometerMin: 0,
      odometerMax: 250000,
      priceMin: 0,
      priceMax: 500000,
      transmissions: [
        { value: 22, text: "Automatic" },
        { value: 23, text: "CVT" },
        { value: 21, text: "Manual" }
      ],
      vehicleFeatures: [
        { value: 6, text: "Night Vision" },
        { value: 5, text: "Telematics" }
      ],
      vehicleExterior: [
        {
          value: 22,
          text: "Electronically Adjustable Mirrors"
        },
        { value: 21, text: "Heated Mirrors" },
        { value: 20, text: "Rear Spoiler" }
      ],
      vehicleInterior: [
        {
          value: 34,
          text: "Illuminated Vanity Mirrors"
        },
        { value: 28, text: "Leather Seats" }
      ],
      vehicleSafety: [
        { value: 41, text: "4 Wheel ABS Brakes" },
        { value: 44, text: "Adaptive Cruise Control" },
        { value: 42, text: "Brake Assist System" },
        { value: 51, text: "Electronic Traction Control" },
        { value: 47, text: "Front Airbags" },
        { value: 48, text: "Lane Departure Warning" },
        { value: 45, text: "Low Tire Pressure Indicator" },
        { value: 71, text: "Passenger Air Bag Sensor" }
      ],
      vehicleAccessories: [
        { value: 63, text: "Back-Up Camera" },
        { value: 56, text: "Bluetooth Hands Free Access" },
        { value: 54, text: "Cruise Control" },
        { value: 65, text: "Keyless Start" },
        { value: 58, text: "Navigation" },
        { value: 62, text: "Upgraded Speakers" },
        { value: 61, text: "Wi-Fi Network" }
      ]
    };

    return inventorySearchFilterValues;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/Inventory.js